import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AllowOnlyNumbersDirective } from '../directives/allow-only-numbers.directive';
import { ProgressBarComponent } from '../components/progress-bar/progress-bar.component';
import { BrowserModule } from '@angular/platform-browser';
import { ReactiveFormsModule } from '@angular/forms';
import { AnModalContainerComponent } from '../components/an-modal-container/an-modal-container.component';



@NgModule({
  declarations: [
    AllowOnlyNumbersDirective,
    ProgressBarComponent,
    AnModalContainerComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    ReactiveFormsModule,
  ],
  exports: [
    AllowOnlyNumbersDirective,
    CommonModule,
    BrowserModule,
    ReactiveFormsModule,
    ProgressBarComponent,
    AnModalContainerComponent
  ]

})
export class DtAnZipcodeSharedModule { }
